import FormControls from 'component/FormControls';
import Page from 'component/Page';
import {
	useState,
} from 'react';
import { Button, Form, Card, Row } from 'react-bootstrap';
import { sendPut } from 'util/request';
import string from 'util/string';
import Urls from 'util/urls';
import {
	focusElement,
	getFormData,
	showConfirm,
	showToast
} from 'util/utils';
import { RiEyeCloseLine } from 'react-icons/ri';
import { ImEye } from 'react-icons/im';

// const LOGIN_ID_LIMIT_LENGTH = 16;
const LOGIN_ID_LIMIT_LENGTH = 50;

const UserChangeAppIdPassword = ({
  data = { id: null, valid: true },
  onUpdated,
}) => {
  //-------------------------------HOOKS-------------------------------------------------------------
  const [showPassword, setShowPassword] = useState(false);

  //------------------------FUNCTIONS----------------------------------------------------------
  const onSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    let formData = getFormData(e.target, {
      rawCol: {
        newPassword: true,
        newPasswordConfirm: true,
      },
    });

    if (!formData?.newPassword) {
      showToast(string.PASSWORD_EMPTY_ERR);
      focusElement('#newPassword');
      return;
    }
		if (!formData?.newPasswordConfirm) {
			showToast(string.CONFIRM_PASSWORD_EMPTY_ERR);
			focusElement('#newPasswordConfirm');
			return;
		}
		if (formData.newPassword !== formData.newPasswordConfirm) {
			showToast(string.PASSWORD_CONFIRM_ERR);
			focusElement('#newPassword');
			return;
		}
		// if (!showPassword) {
    //   if (!formData?.newPasswordConfirm) {
    //     showToast(string.CONFIRM_PASSWORD_EMPTY_ERR);
    //     focusElement('#newPasswordConfirm');
    //     return;
    //   }
    //   if (formData.newPassword !== formData.newPasswordConfirm) {
    //     showToast(string.PASSWORD_CONFIRM_ERR);
    //     focusElement('#newPassword');
    //     return;
    //   }
    // }
		let pocData = {
			pocId: data?.pocId,
			displayName: data?.displayName,
			status: data?.status,
			role: data?.role === 'premium' ? 0 : 1,
			password: formData?.newPassword,
			expirationDate: new Date(),
		};
    showConfirm({
      body: string.POC_ACCOUNT_PASSWORD_CONFIRM,
      defaultAction: () => {
        sendPut({
          url: Urls.pocaccount.update,
          body: pocData,
        }).then((res) => {
            showToast(string.POC_ACCOUNT_PASSWORD_SUCCESS, 'success');
            onUpdated(res);
        }).catch((e) => {

				});
      },
    });
  };

  //------------------------------------RETURN---------------------------------------------------------
  return (
    <>
      <Page
        title={string.APP_ACCOUNT_PASSWORD_CHANGE}
        body={
          <>
            <Card.Title>{string.APP_ACCOUNT_SETTING}</Card.Title>
            <FormControls
              data={data}
              controls={[
                {
                  id: 'username',
                  title: string.APP_LOGIN_ID,
                  readOnly: true,
                },
                {
                  id: 'displayName',
                  title: string.APP_DISPLAY_NAME,
                  readOnly: true,
                },
              ]}
              footer={<></>}
            />
            <Card.Title>{string.APP_PASSWORD_CHANGE}</Card.Title>
            <Form onSubmit={onSubmit}>
              <FormControls
                controls={[
                  {
                    id: 'newPassword',
                    title: string.NEW_PASSWORD,
                    type: showPassword ? 'text' : 'password',
                    defaultValue: '',
                    footer: showPassword ? (
                      <>
                        <ImEye
                          onClick={() => {
                            setShowPassword(false);
                          }}
                        />
                      </>
                    ) : (
                      <>
                        <RiEyeCloseLine
                          onClick={() => {
                            setShowPassword(true);
                          }}
                        />
                      </>
                    ),
                  },
                  {
                    id: 'newPasswordConfirm',
                    title: string.CONFIRM_NEW_PASSWORD,
                    defaultValue: '',
                    type: showPassword ? 'text' : 'password',
                    // type: showPassword ? 'hidden' : 'password',
                    footer: showPassword ? (
                      <>
                        <ImEye
                          onClick={() => {
                            setShowPassword(false);
                          }}
                        />
                      </>
                    ) : (
                      <>
                        <RiEyeCloseLine
                          onClick={() => {
                            setShowPassword(true);
                          }}
                        />
                      </>
                    ),
                  },
                ]}
                footer={<></>}
              />
              <Row className="form-button-row">
                <Button type="submit">{string.APP_ACCOUNT_SAVE}</Button>
              </Row>
            </Form>
          </>
        }
      />
    </>
  );
};

export default UserChangeAppIdPassword;
